// Mobile app store links, injected at build time. Empty when unset — every
// consumer treats "" as "not available" and renders nothing, so the store
// buttons and the mobile app-suggestion banner stay hidden until the URLs
// are configured via VITE_ANDROID_APP_URL / VITE_IOS_APP_URL.
export const ANDROID_APP_URL = import.meta.env.VITE_ANDROID_APP_URL || ''
export const IOS_APP_URL     = import.meta.env.VITE_IOS_APP_URL || ''

export const HAS_APP_LINKS = !!(ANDROID_APP_URL || IOS_APP_URL)

/** Best-effort platform sniff so we can surface the right store first. */
export function detectMobileOS() {
  if (typeof navigator === 'undefined') return null
  const ua = navigator.userAgent || navigator.vendor || ''
  if (/android/i.test(ua)) return 'android'
  if (/iphone|ipad|ipod/i.test(ua) && !window.MSStream) return 'ios'
  return null
}

/** The single most relevant store URL for the current device, if any. */
export function preferredAppUrl() {
  const os = detectMobileOS()
  if (os === 'android' && ANDROID_APP_URL) return ANDROID_APP_URL
  if (os === 'ios' && IOS_APP_URL) return IOS_APP_URL
  return ANDROID_APP_URL || IOS_APP_URL || ''
}
